import { render, staticRenderFns } from "./details-subscription-limits-block.vue?vue&type=template&id=b4736986&scoped=true&"
import script from "./details-subscription-limits-block.vue?vue&type=script&lang=ts&"
export * from "./details-subscription-limits-block.vue?vue&type=script&lang=ts&"
import style0 from "./details-subscription-limits-block.vue?vue&type=style&index=0&id=b4736986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4736986",
  null
  
)

export default component.exports